import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

const PAYMENT_ACCOUNT_URL = `${CRM_API_URL}/billing/payment-account`
const PAYMENT_METHODS_URL = `${PAYMENT_ACCOUNT_URL}/payment-methods`

function fetchPaymentAccount () {
  return axios.get(PAYMENT_ACCOUNT_URL).then((res) => res.data.data)
}

// Без права на биллинг карточка счёта недоступна — статус отдаётся отдельно
function fetchPaymentAccountStatus () {
  return axios.get(`${PAYMENT_ACCOUNT_URL}/status`).then((res) => res.data.data)
}

// Тариф отдельно от счёта: счёт опрашивается по таймеру, тариф нужен только «Моему тарифу»
function fetchTariff () {
  return axios.get(`${PAYMENT_ACCOUNT_URL}/tariff`).then((res) => res.data.data)
}

// Таблица ждёт items + meta.limit, пагинатор Laravel отдаёт data + meta.per_page
function fetchTransactions ({ type, from, to, page, limit, sortBy, sortDesc } = {}) {
  return axios
    .get(`${PAYMENT_ACCOUNT_URL}/transactions`, {
      params: {
        type,
        from,
        to,
        page,
        limit,
        sortBy: Array.isArray(sortBy) ? sortBy[0] : sortBy,
        sortDesc: Array.isArray(sortDesc) ? sortDesc[0] : sortDesc,
      },
    })
    .then((res) => ({
      items: res.data.data,
      meta: {
        total: res.data.meta.total,
        limit: res.data.meta.per_page,
      },
    }))
}

function topup ({ amount, paymentMethodId = null }) {
  return axios
    .post(`${PAYMENT_ACCOUNT_URL}/topup`, { amount, paymentMethodId })
    .then((res) => res.data)
}

function activatePromisedPayment () {
  return axios
    .post(`${PAYMENT_ACCOUNT_URL}/promised-payment/activate`)
    .then((res) => res.data.data)
}

function fetchPayment (id) {
  return axios.get(`${PAYMENT_ACCOUNT_URL}/payments/${id}`).then((res) => res.data.data)
}

function enableAutopay (id) {
  return axios
    .patch(`${PAYMENT_METHODS_URL}/${id}/autopay/enable`)
    .then((res) => res.data.data)
}

function disableAutopay (id) {
  return axios
    .patch(`${PAYMENT_METHODS_URL}/${id}/autopay/disable`)
    .then((res) => res.data.data)
}

function fetchPaymentMethods () {
  return axios.get(PAYMENT_METHODS_URL).then((res) => res.data.data)
}

// Возврат с формы привязки: просим бэк сверить висящую карту с ЮKassa
function checkPendingCard () {
  return axios.post(`${PAYMENT_METHODS_URL}/check-pending`).then((res) => res.data.data)
}

function setDefaultPaymentMethod (id) {
  return axios
    .patch(`${PAYMENT_METHODS_URL}/${id}/default`)
    .then((res) => res.data.data)
}

function enablePaymentMethod (id) {
  return axios
    .patch(`${PAYMENT_METHODS_URL}/${id}/enable`)
    .then((res) => res.data.data)
}

function disablePaymentMethod (id) {
  return axios
    .patch(`${PAYMENT_METHODS_URL}/${id}/disable`)
    .then((res) => res.data.data)
}

function deletePaymentMethod (id) {
  return axios
    .delete(`${PAYMENT_METHODS_URL}/${id}`)
    .then((res) => res.data.data)
}

function bindCard () {
  return axios
    .post(PAYMENT_METHODS_URL)
    .then((res) => res.data)
}

export default {
  fetchPaymentAccount,
  fetchPaymentAccountStatus,
  fetchTariff,
  fetchTransactions,
  topup,
  activatePromisedPayment,
  fetchPayment,
  enableAutopay,
  disableAutopay,
  fetchPaymentMethods,
  checkPendingCard,
  setDefaultPaymentMethod,
  enablePaymentMethod,
  disablePaymentMethod,
  deletePaymentMethod,
  bindCard,
}
